module.exports = __webpack_public_path__ + "static/img/icon-1.df1ecde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-1.png
// module id = 4R6w
// module chunks = 1 3 4 5 6 7